import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromProjects from './projects.reducer';

const selectMapLayersState = createFeatureSelector<fromProjects.State>(
  fromProjects.featureKey
);

export const selectPvgeoId = createSelector(
  selectMapLayersState,
  fromProjects.getPvgeoId
);

export const selectPvgeoGeomsQty = createSelector(
  selectMapLayersState,
  fromProjects.getPvgeoGeomsQty
);

export const selectOuvCollabId = createSelector(
  selectMapLayersState,
  fromProjects.getOuvCollabId
);

export const selectIcadId = createSelector(
  selectMapLayersState,
  fromProjects.getIcadId
);

export const selectIcadGeomsQty = createSelector(
  selectMapLayersState,
  fromProjects.getIcadGeomsQty
);

export const selectZoneId = createSelector(
  selectMapLayersState,
  fromProjects.getZoneId
);

export const selectIcadAPIAddr = createSelector(
  selectMapLayersState,
  fromProjects.getIcadAPIAddr
);

export const selectExtent = createSelector(
  selectMapLayersState,
  fromProjects.getExtent
);

export const selectLegend = createSelector(
  selectMapLayersState,
  fromProjects.getLegend
);

export const selectCity = createSelector(
  selectMapLayersState,
  fromProjects.getCity
);

export const selectConfiguracao = createSelector(
  selectMapLayersState,
  fromProjects.getConfiguracao
);

export const selectVm2CoreMedian = createSelector(
  selectMapLayersState,
  fromProjects.getVm2CoreMedian
);

export const selectMode = createSelector(
  selectMapLayersState,
  fromProjects.getMode
);

export const selectHasBothPortalModes = createSelector(
  selectMapLayersState,
  fromProjects.getHasBothPortalModes
);

export const selectICADDefault = createSelector(
  selectMapLayersState,
  fromProjects.getICADDefault
);

export const selectLayersForms = createSelector(
  selectMapLayersState,
  fromProjects.getLayersForms
);

export const selectLayerForms = (layerName: string) =>
  createSelector(selectLayersForms, (layersForms) => {
    if (layersForms) {
      return layersForms[layerName];
    }
  });

export const selectMapLayers = createSelector(
  selectMapLayersState,
  fromProjects.getLayers
);

export const selectMapLayerByName = (layerName: string) =>
  createSelector(selectMapLayers, (layers) =>
    layers.find(({ name }) => name === layerName)
  );

export const selectZIdexByRepresentation = (representation: string) =>
  createSelector(
    selectMapLayers,
    selectConfiguracao,
    (layers, configuracao) => {
      if (!configuracao || !configuracao.portal) {
        return null;
      }
      const { portal } = configuracao;
      const ids = Object.keys(portal || {});
      const layer = layers
        .filter(({ id }) => ids.includes(id.toString()))
        .find(({ representacao }) => representacao === representation);

      if (!layer) {
        return null;
      }

      const zIndex = portal[layer?.id]?.zIndex;
      return zIndex;
    }
  );

export const selectMapLayerByType = (layerType: string) =>
  createSelector(selectMapLayers, (layers) =>
    layers.find(({ type }) => type === layerType)
  );

export const selectCurrentPvgeoId = createSelector(
  selectMapLayersState,
  fromProjects.getCurrentPvgeoId
);

export const selectCurrentOuvCollabId = createSelector(
  selectMapLayersState,
  fromProjects.getCurrentOuvCollabId
);

export const selectCurrentIcadId = createSelector(
  selectMapLayersState,
  fromProjects.getCurrentIcadId
);

export const selectCurrentZoneId = createSelector(
  selectMapLayersState,
  fromProjects.getCurrentZoneId
);
